export const KEY_A = 'KeyA';
export const KEY_C = 'KeyC';
export const KEY_D = 'KeyD';
export const KEY_N = 'KeyN';
export const KEY_V = 'KeyV';
export const KEY_Z = 'KeyZ';
export const KEY_Y = 'KeyY';
export const KEY_ESC = 'Escape';
export const KEY_TAB = 'Tab';
export const KEY_DELETE = 'Delete';
export const KEY_BACKSPACE = 'Backspace';
export const KEY_ENTER = 'Enter';
export const KEY_NUMPAD_ENTER = 'NumpadEnter';
export const KEY_CTRL_LEFT = 'ControlLeft';
export const KEY_CTRL_RIGHT = 'ControlRight';
export const KEY_SHIFT_LEFT = 'ShiftLeft';
export const KEY_SHIFT_RIGHT = 'ShiftRight';
export const KEY_CMD_LEFT = 'MetaLeft';
export const KEY_CMD_RIGHT = 'MetaRight';
export const KEY_ALT_LEFT = 'AltLeft';
export const KEY_ALT_RIGHT = 'AltRight';
export const KEY_EQUAL = 'Equal';
export const KEY_MINUS = 'Minus';
export const KEY_NUMPAD_ADD = 'NumpadAdd';
export const KEY_NUMPAD_SUBTRACT = 'NumpadSubtract';
export const KEY_ARROW_LEFT = 'ArrowLeft';
export const KEY_ARROW_RIGHT = 'ArrowRight';
export const KEY_ARROW_UP = 'ArrowUp';
export const KEY_ARROW_DOWN = 'ArrowDown';
export const KEYBOARD_KEY_Z = 'z';